export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';